import { SupportedNetwork } from "@cat-protocol/cat-sdk";
import { HistoryItem } from "./components/HistoryItem";
import { TxStatus } from "./api";

export class StorageAPI {

    static getAllHistoryItems(network: SupportedNetwork): HistoryItem[] {
        const history = localStorage.getItem(`${network}-history`);

        if (history == null) {
            return [];
        }
        return JSON.parse(history).filter((item: HistoryItem) => {
            return item && item.txId && item.status && item.type && item.amountOrLocalId && item.symbol;
        }
        ) as HistoryItem[];
    }

    static updateAllHistoryItems(network: SupportedNetwork, items: HistoryItem[]): void {
        localStorage.setItem(`${network}-history`, JSON.stringify(items))
    }


    static getHistoryItemByTxid(network: SupportedNetwork, txId: string): HistoryItem | undefined {
        const history = StorageAPI.getAllHistoryItems(network);
        return history.find(item => item.txId === txId);
    }

    static addOrUpdateHistoryItem(network: SupportedNetwork, historyItem: HistoryItem) {

        const history = StorageAPI.getAllHistoryItems(network);
        const index = history.findIndex(item => item.txId === historyItem.txId);

        if (index > -1) {
            history[index] = historyItem
        } else {
            history.push(historyItem)
        }
        
        StorageAPI.updateAllHistoryItems(network, history);
    }


    static updateHistoryItemTxStatus(network: SupportedNetwork, txId: string, status: TxStatus) {

        const history = StorageAPI.getAllHistoryItems(network);
        const historyItem = history.find(item => item.txId === txId);

        if (historyItem) {
            historyItem.status = status
            StorageAPI.updateAllHistoryItems(network, history);
        }

    }
}